import { createAction, createRequestTypes, createRequestActions } from './utils';
export const FETCH_HOME_PAGE_OPTIONS = 'FETCH_HOME_PAGE_OPTIONS';
export const FETCH_DEFAULT_HOME_PAGE = 'FETCH_DEFAULT_HOME_PAGE';
export const FetchHomePageOptionsActionTypes = createRequestTypes(FETCH_HOME_PAGE_OPTIONS);
export const FetchHomePageOptions = createRequestActions(FetchHomePageOptionsActionTypes);
export const FetchDefaultHomePageActionTypes = createRequestTypes(FETCH_DEFAULT_HOME_PAGE);
export const FetchDefaultHomePage = createRequestActions(FetchDefaultHomePageActionTypes);
export const loadHomePageOptions = () => createAction(FETCH_HOME_PAGE_OPTIONS);
export const loadDefaultHomePage = () => createAction(FETCH_DEFAULT_HOME_PAGE);